import { useEffect, useMemo, useState } from "react";
import FormField from "../FormField";
import "./styles.css";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";

const SubIdentitiesAliasesForm = ({ values, handleChange, handleFormData }) => {
  const intl = useIntl();
  const { types: idTypesOptions } = useSelector((state) => state.types);

  const recordTypes = [
    {
      value: "Alias",
      label: "Alias",
    },
    {
      value: "Sub-Identity",
      label: "Sub Identity",
    },
  ];
  const { isEnableAlias } = useSelector((state) => state.controller);
  const selectedRecordType = useMemo(
    () =>
      isEnableAlias === true ? recordTypes[0]?.value : recordTypes[1]?.value,
    [isEnableAlias],
  );
  const recordTypeOptions = useMemo(
    () =>
      isEnableAlias === false
        ? recordTypes.filter((option) => option.value !== recordTypes[0]?.value)
        : recordTypes,
    [isEnableAlias],
  );
  useEffect(() => {
    if (idTypesOptions?.length && !values?.type && !values?.recordType)
      handleFormData({
        type: idTypesOptions?.[0]?.value,
        recordType: selectedRecordType,
      });
    else if (idTypesOptions?.length && !values?.type) {
      handleFormData({
        type: idTypesOptions?.[0]?.value,
      });
    } else if (!values?.recordType) {
      handleFormData({
        recordType: selectedRecordType,
      });
    }
  }, [idTypesOptions]);
  useEffect(() => {
    handleFormData({
      recordType: selectedRecordType,
    });
  }, [selectedRecordType]);

  const [customSelectTypeActive, setCustomSelectTypeActive] = useState(false);
  const [customSelectRecordTypeActive, setCustomSelectRecordTypeActive] =
    useState(false);

  const handleCustomClick = (fieldName) => {
    if (fieldName === "type")
      setCustomSelectTypeActive(!customSelectTypeActive);
    else if (fieldName === "recordType")
      setCustomSelectRecordTypeActive(!customSelectRecordTypeActive);
  };
  return (
    <div class="grid-container">
      <div class="grid-item">
        <FormField
          type="select"
          label={intl.formatMessage({
            id: "label.record-type",
            defaultMessage: "Record type",
          })}
          options={recordTypeOptions}
          handleChange={handleChange}
          name="recordType"
          value={values?.recordType}
          rules={{
            required: true,
            hasSubmitted: values?.hasSubmited,
            message: "Please select the record type",
          }}
          handleCustomClick={(e) => handleCustomClick(e.target.name)}
          customSelectActive={customSelectRecordTypeActive}
        />
      </div>
      <div class="grid-item">
        <FormField
          type="select"
          label={intl.formatMessage({
            id: "label.id-type",
            defaultMessage: "ID Type",
          })}
          options={idTypesOptions}
          handleChange={handleChange}
          name="type"
          value={values?.type}
          rules={{
            required: true,
            hasSubmitted: values?.hasSubmited,
            message: "Please select the type",
          }}
          handleCustomClick={(e) => handleCustomClick(e.target.name)}
          customSelectActive={customSelectTypeActive}
        />
      </div>
      <div class="grid-item full-width">
        <FormField
          type="text"
          label={intl.formatMessage({
            id: "label.id-value",
            defaultMessage: "ID Value",
          })}
          placeholder={intl.formatMessage({
            id: "input.placeholder.please-fill",
            defaultMessage: "Please fill the value",
          })}
          handleChange={handleChange}
          name="value"
          value={values?.value}
          rules={{
            required: true,
            hasSubmitted: values?.hasSubmited,
          }}
        />
      </div>
    </div>
  );
};

export default SubIdentitiesAliasesForm;
